import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CloudGuard } from "../shared/cloud/cloud.guard";
import { CloudsComponent } from "./clouds/clouds.component";
import { UnexpectedComponent } from "./unexpected/unexpected.component";
import { FeaturesComponent } from "./features/features.component";
import { ActivatedTabGuard } from './activated-tab.guard';
import { ConcurrentAccessComponent } from './concurrent-access/concurrent-access.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/features',
    pathMatch: 'full'
  },
  {
    path: "clouds",
    component: CloudsComponent
  },
  {
    path: "concurrent-access",
    component: ConcurrentAccessComponent
  },
  {
    path: 'features',
    component: FeaturesComponent,
    canActivate: [
      CloudGuard
    ],
    canActivateChild: [ActivatedTabGuard],
    loadChildren: () => import('../main/main.module').then(m => m.MainModule),
  },
  {
    path: "**",
    component: UnexpectedComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortalRoutingModule {}
